import { HomeGroupLayout, HomeworkSubmittedStudentTable } from 'components';
import React from 'react';

/**
 * 學生提交的作業列表頁面
 */

export const HomeworkSubmittedStudentPage = () => {
  return (
    <HomeGroupLayout>
      <HomeworkSubmittedStudentTable />
    </HomeGroupLayout>
  );
};

